import ListingsCollection from '@reverbdotcom/commons/src/components/listings_collection';
import { EVERYWHERE_CODE } from '@reverbdotcom/commons/src/constants';
import { useQuery } from '@reverbdotcom/commons/src/useQuery';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import React from 'react';
import {
  CPListingsRecommendationsQuery,
  CPListingsRecommendationsQueryVariables,
  ListingsCollection as ListingsCollectionQuery,
  reverb_search_ListingsSearchRequest_Sort,
} from '@reverbdotcom/commons/src/gql/graphql';
import {
  COMPONENT_NAME,
  CPRecommendationsRowQuery,
  MIN_COUNT,
  cpListingsRecommendationsVariables,
  useRecommendedListingsTracking,
} from './recommended_listings_common';
import { useMediaQuery } from '@reverbdotcom/cadence/components';
import { isNonUSUser } from '@reverbdotcom/commons/src/user_context_helpers';

const MAX_LISTINGS_MOBILE = 4;

interface IProps {
  title: string;
  listingsLimit: number;
  recsLimit: number;
  componentName?: string;
  recommendedFrom?: ListingsCollectionQuery.Fragment[];
  displayAsGridOnMobile?: boolean;
  sort: reverb_search_ListingsSearchRequest_Sort;
}

export default function CPRecommendationsListingsRow(props: IProps) {
  const user = useUser();
  const showFlags = isNonUSUser(user);
  const isMobile = useMediaQuery('mobile');

  const { data, loading } = useQuery<CPListingsRecommendationsQuery, CPListingsRecommendationsQueryVariables>(
    CPRecommendationsRowQuery,
    {
      // Ignore sticky seller location on Homepage.
      context: {
        headers: {
          'X-Item-Region': EVERYWHERE_CODE,
        },
      },
      ssr: false,
      variables: cpListingsRecommendationsVariables(user, props.listingsLimit, props.recsLimit, props.sort),
    },
  );
  const listings = data?.cpToListingRecs?.searchResponse?.listings || [];
  const recommendationEngineInputIds = data?.cpToListingRecs?.recommendationEngineInputIds || [];
  const recommendationEngineOutputIds = data?.cpToListingRecs?.recommendationEngineOutputIds || [];

  useRecommendedListingsTracking(user, loading, listings.map(listing => listing.id), recommendationEngineInputIds, recommendationEngineOutputIds, props.componentName);
  if (
    !loading &&
    listings.length < MIN_COUNT
  ) {
    return null;
  }

  return (
    <ListingsCollection
      componentName={props.componentName || COMPONENT_NAME}
      listings={!isMobile ? listings : listings.slice(0, MAX_LISTINGS_MOBILE)}
      loading={loading}
      title={props.title}
      showFlags={showFlags}
      thumbnailTitleContent={props.recommendedFrom}
      displayAsGridOnMobile={props.displayAsGridOnMobile}
    />
  );
}
